
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/dashboard",
      function () {
        return require("private-next-pages/mobiworkx/dashboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/dashboard"])
      });
    }
  